import { Button } from "@/components/ui/button";
import { AuthLayout } from "@/components/layout/AuthLayout";
import { useAuth } from "@/context/AuthContext";

export default function WaitingListPage() {
  const { signOut, refreshApprovalStatus } = useAuth();

  return (
    <AuthLayout
      title="Application received"
      subtitle="Your account is on the waiting list"
      leftContent={{
        title: "Welcome to Youzu",
        subtitle: "Your application is being reviewed",
        description: "We'll let you know when your account is ready.",
        trustIndicator: "Account review",
      }}
    >
      <div className="space-y-6 text-center">
        <p className="text-gray-700">
          You are in the waiting list, and admin will check your application for approval.
        </p>
        <p className="text-sm text-gray-600">We’ll email you when your account is approved.</p>
        <div className="flex justify-center gap-3">
          <Button type="button" onClick={() => void refreshApprovalStatus()}>
            Check status
          </Button>
          <Button type="button" variant="outline" onClick={() => void signOut()}>
            Sign out
          </Button>
        </div>
      </div>
    </AuthLayout>
  );
}
